import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import ColorPickerInput from "../../common/ColorPicker";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL, getDimension } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [headerColor, setHeaderColor] = useState("");
  const [footerColor, setFooterColor] = useState("");

  const GetEditData = async () => {
    const response = await getData(`/home/app-setup/vender/${id}`);
    reset(response?.data);
    setHeaderColor(response?.data?.header_color);
    setFooterColor(response?.data?.footer_color);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    formState: { errors },
    reset,
  } = useForm();

  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("return_days", data?.return_days);
      finalData.append("delivery_time", data?.delivery_time);
      const response = await postData(`/home/app-setup/vender`, finalData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit App Setup
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={6}>
                <div className="main-form-section mb-3">
                  <Row className="justify-content-center">
                    <Form.Label>Return Days</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="Return Days"
                          placeholder="Return Days"
                          className={classNames("", {
                            "is-invalid": errors?.return_days,
                          })}
                          {...register("return_days", {
                            required: "Return Days is required",
                          })}
                        />
                      </InputGroup>
                      {errors.return_days && (
                        <span className="text-danger">
                          {errors.return_days.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mb-3">
                  <Row className="justify-content-center">
                    <Form.Label>Delivery Time</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="number"
                          name="delivery_time"
                          placeholder="Delivery Time"
                          className={classNames("", {
                            "is-invalid": errors?.delivery_time,
                          })}
                          {...register("delivery_time", {
                            required: "Delivery Time is required",
                          })}
                        />
                      </InputGroup>
                      {errors.delivery_time && (
                        <span className="text-danger">
                          {errors.delivery_time.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <div className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </div>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
